import config from '@config';

import api from 'api';

/**
 * Fonctions de l'API REST personnalisée du thème
 */
export default {
	/**
	 * Retourne la valeur d'un champ bloginfo du site.
	 * Si le champ est inconnu ou non autorisé en lecture,
	 * retourne une chaîne vide
	 *
	 * @param {String} name
	 */
	getBloginfo(name) {
		return new api.WPRequest(config.kookvue_api_path)
			.get('bloginfo/:name')
			.ifbind(name !== undefined, 'name', name)
			.execute();
	},
};



// WEBPACK FOOTER //
// ./src/api/kookvue.js